import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-3">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              Latest CSSBuy Sheet Guides
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              SEO articles to boost your shopping workflow
            </p>
          </div>
          <Link
            to="/cssbuy-spreadsheet-complete-guide/"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 whitespace-nowrap transition-colors"
          >
            View All Guides
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              className="group relative rounded-lg overflow-hidden aspect-[4/5] cursor-pointer"
            >
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute top-4 right-4">
                <span className="inline-block px-3 py-1 rounded-full bg-background-950/60 text-white text-xs font-medium">
                  {article.category}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white text-base md:text-lg font-heading font-semibold leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-white/60 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}